import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import RegisterModal from './RegisterModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import './Login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false);
  const { login, error, clearError } = useAuth();

  useEffect(() => {
    if (error) {
      // Mostrar mensagem de erro se houver
      const errorElement = document.getElementById('errorMessage');
      if (errorElement) {
        errorElement.textContent = error;
        errorElement.style.display = 'block';
      }
    }
  }, [error]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();

    try {
      await login(email, password);
      // O redirecionamento será tratado pelo contexto de autenticação
    } catch (error: any) {
      // Erro já tratado pelo contexto de autenticação
    }
  };

  const togglePasswordVisibility = () => {
    const passwordField = document.getElementById('password') as HTMLInputElement;
    const toggleIcon = document.querySelector('.password-toggle');
    
    if (passwordField && toggleIcon) {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        if (toggleIcon instanceof HTMLElement) {
          toggleIcon.textContent = '🙈';
        }
      } else {
        passwordField.type = 'password';
        if (toggleIcon instanceof HTMLElement) {
          toggleIcon.textContent = '👁️';
        }
      }
    }
  };

  const showForgotPassword = () => {
    setIsForgotPasswordModalOpen(true);
  };

  const handleRegisterCompany = () => {
    setIsRegisterModalOpen(true);
  };

  const handleRegisterSuccess = () => {
    // TODO: Implementar ações após registro bem-sucedido
  };

  const clearMessages = () => {
    const errorMessage = document.getElementById('errorMessage');
    const successMessage = document.getElementById('successMessage');
    
    if (errorMessage) errorMessage.style.display = 'none';
    if (successMessage) successMessage.style.display = 'none';
  };

  // Limpar mensagens ao digitar
  useEffect(() => {
    const emailInput = document.getElementById('email');
    const passwordInput = document.getElementById('password');
    
    const clearMessagesHandler = () => clearMessages();
    
    if (emailInput) {
      emailInput.addEventListener('input', clearMessagesHandler);
    }
    if (passwordInput) {
      passwordInput.addEventListener('input', clearMessagesHandler);
    }
    
    return () => {
      if (emailInput) {
        emailInput.removeEventListener('input', clearMessagesHandler);
      }
      if (passwordInput) {
        passwordInput.removeEventListener('input', clearMessagesHandler);
      }
    };
  }, []);

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="logo-section">
          <img
            className="logo"
            src="/images/logo-confereai.png"
            alt="Logo ConfereAí"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
          <p className="logo-subtitle">Checklist de Veículos e Máquinas</p>
        </div>

        <div id="errorMessage" className="error-message" style={{ display: 'none' }}></div>
        <div id="successMessage" className="success-message" style={{ display: 'none' }}></div>

        <form id="loginForm" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <div className="input-wrapper">
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="Digite seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
              <span className="input-icon">📧</span>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <div className="input-wrapper">
              <input 
                type="password" 
                id="password" 
                name="password" 
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <span 
                className="input-icon password-toggle" 
                onClick={togglePasswordVisibility}
                style={{ cursor: 'pointer' }}
              >
                👁️
              </span>
            </div>
          </div>

          <button
            type="submit"
            className="login-btn"
            id="loginBtn"
          >
            <span id="btnText">Entrar</span>
          </button>
        </form>

        <div className="forgot-password">
          <button type="button" onClick={showForgotPassword} className="forgot-password-btn">
            Esqueceu sua senha?
          </button>
        </div>

        <div className="register-link">
          <button 
            type="button" 
            onClick={handleRegisterCompany} 
            className="register-link-btn"
          >
            Ainda não possuo cadastro
          </button>
        </div>
      </div>

      <RegisterModal
        isOpen={isRegisterModalOpen}
        onClose={() => setIsRegisterModalOpen(false)}
        onRegisterSuccess={handleRegisterSuccess}
      />

      <ForgotPasswordModal
        isOpen={isForgotPasswordModalOpen}
        onClose={() => setIsForgotPasswordModalOpen(false)}
      />
    </div>
  );
};

export default Login;
